// Package Imports
import PageSkeleton from '@/core/components/page-skeleton'
import RouteError from '@/core/components/route-error'
import { createRoute, lazyRouteComponent } from '@tanstack/react-router'

// Core Imports
import { queryClient } from '@/core/lib/query-client'
import { toAdminListParams } from '@/core/lib/table-query'

// External Module Imports
import { dashboardRoute } from '@/modules/dashboard/dashboard.routes'

// Module Imports
import {
  teamAchievementDetailQueryOptions,
  teamAchievementListQueryOptions,
} from '@/modules/team-achievement/team-achievement.hooks'
import { teamAchievementSearchSchema } from '@/modules/team-achievement/team-achievement.schemas'

export const teamAchievementRoute = createRoute({
  path: '/team-achievements',
  getParentRoute: () => dashboardRoute,
  errorComponent: ({ error, reset }) => (
    <RouteError error={error} reset={reset} />
  ),
})

export const teamAchievementListRoute = createRoute({
  getParentRoute: () => teamAchievementRoute,
  path: '/',
  head: () => ({
    meta: [{ title: 'Takım Başarımları' }],
  }),
  validateSearch: teamAchievementSearchSchema,
  loaderDeps: ({ search }) => search,
  loader: async ({ deps }) => {
    await queryClient.ensureQueryData(
      teamAchievementListQueryOptions(toAdminListParams(deps))
    )
  },
  pendingComponent: () => <PageSkeleton />,
  pendingMs: 100,
  component: lazyRouteComponent(
    () => import('@/modules/team-achievement/pages/list-team-achievement.page')
  ),
})

export const teamAchievementCreateRoute = createRoute({
  getParentRoute: () => teamAchievementRoute,
  path: '/create',
  head: () => ({
    meta: [{ title: 'Takım Başarımı Oluştur' }],
  }),
  component: lazyRouteComponent(
    () =>
      import('@/modules/team-achievement/pages/create-team-achievement.page')
  ),
})

export const teamAchievementDetailRoute = createRoute({
  getParentRoute: () => teamAchievementRoute,
  path: '/$id',
  head: () => ({
    meta: [{ title: 'Takım Başarımı Detayı' }],
  }),
  loader: async ({ params: { id } }) => {
    await queryClient.ensureQueryData(teamAchievementDetailQueryOptions(id))
  },
  pendingComponent: () => <PageSkeleton />,
  pendingMs: 100,
  component: lazyRouteComponent(
    () =>
      import('@/modules/team-achievement/pages/detail-team-achievement.page')
  ),
})

export const teamAchievementEditRoute = createRoute({
  getParentRoute: () => teamAchievementRoute,
  path: '/$id/edit',
  head: () => ({
    meta: [{ title: 'Takım Başarımı Düzenle' }],
  }),
  component: lazyRouteComponent(
    () => import('@/modules/team-achievement/pages/edit-team-achievement.page')
  ),
})
